'use strict';

define('lib/analytics/blocks/user.block',[], function () {
  return function userBlock(user) {
    return {
      user_contact_preference: user.preferedContact || '',
      user_city: user.customerCity || '',
      user_state: user.customerState || '',
      user_zipcode: user.customerZipCode || '',
      user_preferred_time: user.preferredTime || '',
      user_preferred_date: user.preferredDate || ''
    };
  };
});

